const generalDrawer = document.querySelector('#generalDrawer');
const drawerContents = document.querySelector('#generalDrawerContents');
const initDrawer = () => {
  document
    .querySelectorAll('.general-drawer__container')
    .forEach((drawer) =>
      drawer
        .querySelectorAll('.general-drawer__close, .general-drawer__backdrop')
        .forEach((closer) =>
          closer.addEventListener('click', () => closeDrawer(drawer)),
        ),
    );
};

const openDrawer = (drawer = null) => {
  if (drawer && drawer.id !== 'generalDrawer') {
    drawer.classList.add('open');
    document.querySelector('html').style.overflow = 'hidden';
  } else {
    if (!generalDrawer) return;
    generalDrawer.classList.add('open');
    document.querySelector('html').style.overflow = 'hidden';
  }
};

const closeDrawer = (drawer = null) => {
  if (drawer) {
    drawer.classList.remove('open');
    document.querySelector('html').style.overflow = '';
  } else {
    if (!generalDrawer) return;
    generalDrawer.classList.remove('open');
    document.querySelector('html').style.overflow = '';
    setTimeout(() => {
      const drawerTitle = generalDrawer.querySelector('.general-drawer__title');
      if (drawerTitle) drawerTitle.innerHTML = '';

      const drawerHeading = generalDrawer.querySelector(
        '.general-drawer__heading',
      );
      if (drawerHeading) drawerHeading.innerHTML = '';

      const drawerContent = generalDrawer.querySelector(
        '.general-drawer__content',
      );
      if (drawerContent) drawerContent.innerHTML = '';
    }, 1000);
  }
};

const closeAllDrawers = () => {
  document.querySelectorAll('.general-drawer__container').forEach((drawer) => {
    closeDrawer(drawer);
  });
};

const populateDrawer = (template) => {
  if (!template) return;
  if (generalDrawer.classList.contains('open')) {
    closeAllDrawers();
    setTimeout(() => {
      populateDrawer(template);
    }, 1000);
  } else {
    if (template.tagName.toLowerCase() === 'script') {
      const templateBody = new DOMParser()
        .parseFromString(template.innerText, 'text/html')
        .querySelector('[data-drawer-container]');
      if (!templateBody) return;

      const titleEl = templateBody.querySelector('[data-drawer-title]');
      const drawerTitle = generalDrawer.querySelector('.general-drawer__title');
      if (titleEl && drawerTitle) drawerTitle.innerHTML = titleEl.innerHTML;

      const headingEl = templateBody.querySelector('[data-drawer-heading]');
      const drawerHeading = generalDrawer.querySelector(
        '.general-drawer__heading',
      );
      if (headingEl && drawerHeading)
        drawerHeading.innerHTML = headingEl.innerHTML;

      const contentEl = templateBody.querySelector('[data-drawer-content]');
      const drawerContent = generalDrawer.querySelector(
        '.general-drawer__content',
      );
      if (contentEl && drawerContent)
        drawerContent.innerHTML = contentEl.innerHTML;
      window.dAgency.initInputs(drawerContent);
      const parsleyForm = drawerContent.querySelector('.parsley-form');
      if (parsleyForm) $(parsleyForm).parsley();
      openDrawer();
    } else {
      const drawer = template.closest('.general-drawer__container');
      if (drawer) openDrawer(drawer);
    }
  }
};

export { initDrawer, openDrawer, closeDrawer, closeAllDrawers, populateDrawer };
